import AppTheme from "./../Themes";
const themeChangerData = [
  {
    themeName: "Default",
    backgroundColor: AppTheme.default.midBackground,
    highlight: AppTheme.default.highlight,
    theme: "default",
  },
  {
    themeName: "Atom One Dark",
    backgroundColor: AppTheme.atom_one_dark.midBackground,
    highlight: AppTheme.atom_one_dark.highlight,
    theme: "atom_one_dark",
  },
  {
    themeName: "Github Dark",
    backgroundColor: AppTheme.github_dark.midBackground,
    highlight: AppTheme.github_dark.highlight,

    theme: "github_dark",
  },
  {
    themeName: "Comminity Material",
    backgroundColor: AppTheme.community_material.midBackground,
    highlight: AppTheme.community_material.highlight,
    theme: "community_material",
  },
  {
    themeName: "Vscode Dark",
    backgroundColor: AppTheme.vscode_dark.midBackground,
    highlight: AppTheme.vscode_dark.highlight,
    theme: "vscode_dark",
  },
];

export default themeChangerData;
